// extracted by mini-css-extract-plugin
export default {"public_layout":"PublicLayout_public_layout__IEB33","public_layout__content__children":"PublicLayout_public_layout__content__children__Lnqiq"};